import { CapabilitySet, KnownCapability } from "@/types/capability.types";

/**
 * Whether the given capability set contains the key. `null`/`undefined` sets
 * (context not resolved yet, BE field missing) always fail closed — under strict
 * RBAC a missing or empty set is a denial, never a widening.
 */
export const hasCapability = (
  set: CapabilitySet | null | undefined,
  key: KnownCapability
): boolean => set?.has(key) ?? false;

/** Whether the set contains at least one of the given keys. */
export const hasAnyCapability = (
  set: CapabilitySet | null | undefined,
  keys: readonly KnownCapability[]
): boolean => keys.some((key) => hasCapability(set, key));
